import React, { useEffect } from 'react'

const Player = React.forwardRef(
  (
    props: {
      ref: (player: { seek: (to: number) => void }) => void
      source: { uri: string }
      paused: boolean
      volume?: number
      audioOnly?: boolean
      style?: any
      playInBackground?: boolean
      ignoreSilentSwitch?: string
      playWhenInactive?: boolean
      onProgress?: (data: {
        currentTime: number
        seekableDuration: number
      }) => void
      onEnd?: () => void
      onLoad?: () => void
      onLoadStart?: () => void
      onError?: (error: any) => void
    },
    ref,
  ) => {
    const audioRef = React.useRef<HTMLAudioElement | undefined>(undefined)

    useEffect(() => {
      if (props.paused) {
        audioRef.current?.pause()
      } else {
        audioRef.current?.play()
      }
    }, [props.paused])

    useEffect(() => {
      if (props.volume !== undefined && audioRef.current) {
        audioRef.current.volume = props.volume
      }
    }, [props.volume])

    // Don't render audio element if no valid source
    if (!props.source.uri || props.source.uri.trim() === '') {
      return null
    }

    return (
      <audio
        ref={(r) => {
          if (r) {
            audioRef.current = r
            // Check if ref is a function (old pattern) or should be used as ref callback (new pattern)
            if (typeof ref === 'function') {
              ref({
                seek: (to: number) => {
                  r.currentTime = to
                },
                setNativeProps: () => {},
              })
            }
          }
        }}
        onTimeUpdate={(event) => {
          props.onProgress?.({
            currentTime: event.currentTarget.currentTime,
            seekableDuration: event.currentTarget.duration,
          })
        }}
        onLoadedData={() => props.onLoad?.()}
        onLoadStart={() => props.onLoadStart?.()}
        onError={(e) => props.onError?.(e)}
        onEnded={() => props.onEnd?.()}
        src={props.source.uri}
        autoPlay
      />
    )
  },
)

export default Player
